import React, { useState, useEffect } from 'react'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import '../../style/style.css'

function MicrositeModal(props) {

  const [template, setTemplate] = useState(null)
  const [submitClose, setSubmitClose] = useState(false)
  const [microSiteTemplate, setMicroSiteTemplate] = useState([])
  const [microSiteMyTemplate, setMicroSiteMyTemplate] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchMicroSiteTemplate = async () => {
      try {
        setLoading(true)
        await http.get("event-micro-site-template")
        .then((res) => {
          if (res.data.micro_site) {
            setMicroSiteTemplate(res.data.micro_site)
            setLoading(false)
          }
        }).catch((err) => {
          setLoading(false)
        })
      } catch (error) {
        setLoading(false)
      }
  }

  useEffect(() => {
    fetchMicroSiteTemplate()
  },[])

  const handleSubmit = () => {
    if (template) {
      console.log(template)
      props.setData(template)
    }
  }

  const changeValue = (item) => {
    setTemplate(item)
    setSubmitClose(true)
  }

  useEffect(() => {
    if (props.hasOwnProperty('oldItem')) {
      if (props.oldItem) {
        let indx = microSiteTemplate.findIndex(item => item.id == props.oldItem)
        setTemplate(microSiteTemplate[indx])
      }

      console.log(template)
    }
  }, [props])

  const fetchMyTempate = async () => {
    setLoading(true)
    try {
      setLoading(true)
      await http.get("user/saved/social-gallery-template")
      .then((res) => {
        const responseData = res.data.data.data
        let myTemplateData = []
        responseData.forEach(data=>{
          let customData = {
            name: data.name,
            my_template_id: data.id,
            contents: data.contents,
            ...data.social_template
          }

          myTemplateData.push(customData)
        })
        setMicroSiteMyTemplate(myTemplateData)
        setLoading(false)
      }).catch((err) => {
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
    
  }


  return (
    <div className="modal fade" id="micro-site" tabindex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Select Your Social Gallery</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">	<span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="modal-tab-header">
              <ul className="mb-3 nav nav-pills justify-content-around" id="email-template-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <span
                    className="tab-item active"
                    id="email-temp-home-tab"
                    href="#email-temp-home"
                    role="tab"
                    data-toggle="tab"
                    aria-controls="email-temp-home"
                    aria-selected="false"
                  >
                    Standard Template
                  </span>
                </li>
                <li className="nav-item" role="presentation">
                  <span
                    className="tab-item"
                    id="email-temp-profile-tab"
                    data-toggle="tab"
                    href="#email-temp-profile"
                    role="tab"
                    aria-controls="email-temp-profile"
                    aria-selected="false"
                    onClick={fetchMyTempate}
                  >
                    My Template
                  </span>
                </li>
              </ul>
            </div>

            <div className="tab-content template-content" id="email-temp-tabContent">
              <div
                className="tab-pane fade show active"
                id="email-temp-home"
                role="tabpanel"
                aria-labelledby="email-temp-home-tab"
              >
                <div className="standared-template">
                  <div className="row">
                    {loading ? 
                        <div className="col-md-12" style={{display:'flex', justifyContent:"center", alignItems:'center', width:'100%', minHeight:'40vh'}}>
                          <span className="spinner-border" role="status" aria-hidden="true"></span>
                        </div>
                      :microSiteTemplate.map((item, index) => (
                        <div className="my-2 col-md-2 text-center" onClick={e => changeValue(item)} key={`microsite-template-image-${index}`}>
                          <div className={`template-item ${template && 'my_social_gallery_id' in template === false && template.id === item.id && 'active-template'}`}>
                            <img src={`${URL_S3}image/micro_site/${item.template_image}`} alt="template-1" className="img-fluid" />
                          </div>
                          <button 
                            type="button" 
                            onClick={e => {
                              props.micro_site ?
                              window.location.href = `/edit-socail-template/${item.id}/${props.micro_site}`
                              : window.location.href = `/edit-socail-template/${item.id}`
                            }} 
                            className="btn btn-sm btn-outline-primary mt-3"
                          >Edit Template</button>
                        </div>
                      ))
                    }

                  </div>

                </div>
              </div>
              <div
                className="tab-pane fade show"
                id="email-temp-profile"
                role="tabpanel"
                aria-labelledby="email-temp-profile-tab"
                
              >
                <div className="row">
                  {loading ? 
                    <div className="col-md-12" style={{display:'flex', justifyContent:"center", alignItems:'center', width:'100%', minHeight:'40vh'}}>
                        <span className="spinner-border" role="status" aria-hidden="true"></span>
                      </div>
                    :microSiteMyTemplate && 
                    microSiteMyTemplate.length > 0 ?
                    microSiteMyTemplate.map((item, index) => (
                      <div 
                        className="my-2 col-md-2 text-center" 
                        onClick={e => 
                          changeValue({ id: item.id, template_image: item.template_image, my_social_gallery_id: item.my_template_id ,
                          contents: item.contents
                        })}
                        key={`microsite-template-image-${index}`}
                      >
                        <div className={`template-item ${template && template.my_social_gallery_id === item.my_template_id && 'active-template'}`}>
                          <img src={`${URL_S3}image/micro_site/${item.template_image}`} alt="template-1" className="img-fluid" />
                        </div>
                        <p className="text-center">{item.name}</p>
                      </div>
                    ))
                    :
                    <div className="col-md-12" style={{display:'flex', justifyContent:"center", alignItems:'center', width:'100%', minHeight:'40vh'}}>
                        <h4>No template found</h4>
                      </div>
                  }
                </div>
              </div>
            </div>

          </div>
          <div className="modal-footer">
            <button type="button" className="px-5 m-1 btn btn-secondary radius-30" data-dismiss="modal">Close</button>
            <button type="button" className="px-5 m-1 btn btn-primary radius-30" onClick={handleSubmit} data-dismiss={submitClose && "modal"}>Save changes</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MicrositeModal
